angular.module('leanlaw').factory('originationDefinition_obsolete', ['$q', 'singleRequest', 'clientMatterManager', function ($q, singleRequest) {
  const cancel = params => {
    singleRequest.cancel('compensation');
  };
  const userRows = clients => {
    const rows = [];
    clients.forEach(client => {
      client.matters.forEach(matter => {
        if (!matter.data.origination.originatorDebit) return;
        rows.push({
          values: {
            id: {
              value: matter.matter.reference
            },
            client: {
              value: client.client && client.client.name
            },
            matter: {
              value: matter.matter && matter.matter.name
            },
            origination: {
              value: matter.data.origination.percentage
            },
            amount: {
              value: matter.data.origination.originatorDebit
            }
          }
        });
      });
    });
    return rows;
  };
  const load = async ({
    query,
    filter
  }) => {
    const request = {
      ...query,
      primary: 'users',
      secondary: 'clients',
      data: 'payments',
      status: 'all',
      scope: 'all'
    };
    const report = await singleRequest.apiCall('compensation').getReport(request);

    // create rows and subrows for group of users and items
    const rows = report.users.map(user => {
      return {
        id: user.user && user.user.id,
        label: `${user.user.name} (${user.user.initials})`,
        italic: true,
        values: {
          id: {
            value: undefined
          },
          client: {
            value: undefined
          },
          matter: {
            value: undefined
          },
          origination: {
            value: undefined
          },
          amount: {
            value: user.data.origination.originatorDebit
          }
        },
        rows: userRows(user.clients)
      };
    }).filter(row => row.rows.length);
    return {
      rows
    };
  };
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'id',
      label: `Origination`,
      subrow: {
        label: 'Detail',
        default: true,
        title: true
      },
      totals: {
        rows: true,
        totalLabelCells: 3
      },
      showFilters: {
        distribution: true,
        dateRange: true
      },
      columns: [{
        id: 'id',
        label: 'Id'
      }, {
        id: 'matter',
        label: me.terms.Matter
      }, {
        id: 'origination',
        label: 'Origination',
        filter: 'percentage'
      }, {
        id: 'amount',
        label: 'Amount',
        filter: 'amount',
        number: true
      }]
    };
  };
  return {
    structure,
    load,
    cancel
  };
}]);